<template>
  <div>
    <div
      v-show="!isLoading"
      ref="chart" />
  </div>
</template>

<script>
import c3 from 'c3';

export default {
  components: {
    c3,
  },

  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      isLoading: true,
      color_pattern: ['#218B82', '#9AD9DB', '#E5DBD9', '#98D4BB', '#EB96AA', '#DDF2F4', '#84A6D6', '#4382BB', '#E4CEE0', '#A15D98', '#C6C9D0', '#C54B6C', '#E5B3BB', '#C47482', '#D5E4C3', '#698396', '#A9C8C0', '#DBBC8E', '#AE8A8C', '#7C98AB', '#E5DBD9', '#98D4BB', '#EB96AA', '#DDF2F4', '#84A6D6', '#4382BB', '#E4CEE0', '#A15D98', '#C6C9D0', '#C54B6C', '#E5B3BB', '#C47482', '#D5E4C3', '#698396', '#A9C8C0', '#DBBC8E', '#AE8A8C', '#7C98AB'],
    };
  },

  mounted() {
    if (this.dataComponent.type === 'bar_chart') this.initBarChart();
    else if (this.dataComponent.type === 'line_chart') this.initLineChart();
    else if (this.dataComponent.type === 'pie_chart') this.initPieChart();
  },

  methods: {
    initBarChart() {
      this.isLoading = false;
      c3.generate({
        data: {
          type: 'bar',
          columns: [
            ['data1', 30, 200, 100, 400, 150, 250],
            ['data2', 130, 100, 140, 200, 150, 50],
          ],
        },
        size: {
          height: 230,
        },
        axis: {
          x: {
            label: {
              text: this.dataComponent.x_axis_field.replace(/_/g, ' '),
              position: 'outer-middle',
            },
          },
          y: {
            label: {
              text: this.dataComponent.y_axis_field.replace(/_/g, ' '),
              position: 'outer-middle',
            },
          },
        },
        bar: {
          width: {
            ratio: 0.8,
          },
          space: 0.2,
        },
        bindto: this.$refs.chart,
        color: {
          pattern: this.color_pattern,
        },
      });
    },

    initLineChart() {
      this.isLoading = false;
      c3.generate({
        data: {
          type: 'line',
          columns: [
            ['data1', 30, 200, 100, 400, 150, 250],
            ['data2', 50, 20, 10, 40, 15, 25],
            ['data3', 130, 150, 200, 300, 200, 100],
          ],
        },
        size: {
          height: 230,
        },
        axis: {
          x: {
            label: {
              text: this.dataComponent.x_axis_field.replace(/_/g, ' '),
              position: 'outer-middle',
            },
          },
          y: {
            label: {
              text: this.dataComponent.y_axis_field.replace(/_/g, ' '),
              position: 'outer-middle',
            },
          },
        },
        bar: {
          width: {
            ratio: 0.8,
          },
          space: 0.2,
        },
        bindto: this.$refs.chart,
        legend: {
          hide: true,
        },
        color: {
          pattern: this.color_pattern,
        },
      });
    },

    initPieChart() {
      this.isLoading = false;
      c3.generate({
        data: {
          type: 'pie',
          columns: [
            ['data1', 30, 200, 100, 400, 150, 250],
            ['data2', 50, 20, 10, 40, 15, 25],
            ['data3', 130, 150, 200, 300, 200, 100],
          ],
        },
        size: {
          height: 230,
        },
        axis: {
          x: {
            label: {
              text: this.dataComponent.x_axis_field.replace(/_/g, ' '),
              position: 'outer-middle',
            },
          },
          y: {
            label: {
              text: this.dataComponent.y_axis_field.replace(/_/g, ' '),
              position: 'outer-middle',
            },
          },
        },
        bar: {
          width: {
            ratio: 0.8,
          },
          space: 0.2,
        },
        bindto: this.$refs.chart,
        legend: {
          hide: true,
        },
        color: {
          pattern: this.color_pattern,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dummy/DummyCanvasChart.vue